export const VIEW_MODE_OPTIONS = [
  { text: 'Heatmap by pins', value: 'heatmap' },
  { text: 'Overlay by pins', value: 'overlay' },
  { text: 'Coldmap by pins', value: 'coldmap' },
  { text: 'Spotlight by pins', value: 'spotlight' },
  { text: 'Heatmap by clusters', value: 'heatmapclusters' },
  { text: 'Overlay by clusters', value: 'overlayclusters' },
  { text: 'Pins', value: 'dots' },
  { text: 'Original', value: 'original' }
]

export const DEFAULT_VIEW_MODE = 'heatmap'
export const DEFAULT_AUTO_RECOGNITION_VALUE = 'both'
export const RECOGNITION_MODE_OPTIONS = [
  { text: '<b>Text &amp; objects</b> recognition', value: 'both' },
  { text: '<b>Text</b> only recognition', value: 'text' },
  { text: '<b>Objects</b> only recognition', value: 'object' }
]

export const CLUSTER_FORM_MODE = {
  OFF: 'off',
  RECOGNITION: 'recognition',
  ADD: 'add',
  EDIT: 'edit'
}

export const STAT_TYPE_OPTIONS = [
  { text: 'Pin statistics', value: 'pins' },
  { text: 'Cluster statistics', value: 'clusters' }
]

export const BLOCK_TYPE_OPTIONS = [
  { text: 'All clusters', value: 'all' },
  { text: 'Clusters selected above', value: 'selected' },
  { text: 'Custom clusters', value: 'custom' },
  { text: 'Paragraph clusters', value: 'paragraph' },
  { text: 'Word clusters', value: 'word' },
  { text: 'Object clusters', value: 'object' },
  { text: 'Editor-defined clusters', value: 'editor' }
]

export const STOP_WORD_LEVEL_OPTIONS = [
  { text: '#1. "the", "we", "if", etc.', value: '1' },
  { text: '#2. "can", "more", "want", etc.', value: '2' },
  { text: '#3. "ever", "several", "top", etc.', value: '3' },
  { text: '#4. Hide numbers.', value: 'n' },
  { text: '#5. Hide one-letter words.', value: 'l' },
  { text: '#6. Hide symbols.', value: 's' }
]

export const DEFAULT_STAT_TYPE = 'pins'
export const DEFAULT_BLOCK_TYPE = 'all'
export const DEFAULT_STOP_WORD_LEVEL = ['1', '2', 'l', 's']

export const DEFAULT_ERROR = 'Something went wrong! Please, try again later!'
export const HM_CLUSTER = 'hm.cluster'
export const POLL_INTERVAL = 10000

export const TIPS = [
  {
    id: 1,
    text: 'Draw your cluster using polygon tool',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.28 30"><defs><style>.cls-1{fill:#444;}.cls-2{fill:#73b0ac;stroke:#f7931e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#fff;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Group_2516" data-name="Group 2516"><rect id="Rectangle_175" data-name="Rectangle 175" class="cls-1" width="46.28" height="30"/></g><g id="Group_2517" data-name="Group 2517"><path id="Path_2542" data-name="Path 2542" class="cls-2" d="M10.82,25.38l3.81-11.17L10.82,6.83H22.49L38,14.21"/><circle id="Ellipse_17" data-name="Ellipse 17" class="cls-3" cx="14.38" cy="14.42" r="1.32"/><circle id="Ellipse_18" data-name="Ellipse 18" class="cls-3" cx="22.24" cy="6.83" r="1.32"/><circle id="Ellipse_19" data-name="Ellipse 19" class="cls-3" cx="10.82" cy="6.83" r="1.32"/><circle id="Ellipse_20" data-name="Ellipse 20" class="cls-3" cx="37.97" cy="14.14" r="1.32"/><circle id="Ellipse_21" data-name="Ellipse 21" class="cls-3" cx="10.82" cy="25.35" r="1.32"/></g></g></g></svg>`
  },
  {
    id: 2,
    text: 'Double-click or right-click to close the cluster',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.28 30"><defs><style>.cls-1{fill:#444;}.cls-2{fill:#73b0ac;stroke:#f7931e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#fff;}.cls-4{fill:#29abe2;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Group_2416" data-name="Group 2416"><rect id="Rectangle_175" data-name="Rectangle 175" class="cls-1" width="46.28" height="30"/></g><g id="Group_2417" data-name="Group 2417"><path id="Path_2542" data-name="Path 2542" class="cls-2" d="M11.11,25.38l3.82-11.17L11.11,6.83H22.78l15.49,7.38Z"/><circle id="Ellipse_22" data-name="Ellipse 22" class="cls-3" cx="14.68" cy="14.42" r="1.32"/><circle id="Ellipse_23" data-name="Ellipse 23" class="cls-3" cx="22.53" cy="6.83" r="1.32"/><circle id="Ellipse_24" data-name="Ellipse 24" class="cls-3" cx="11.11" cy="6.83" r="1.32"/><circle id="Ellipse_25" data-name="Ellipse 25" class="cls-3" cx="38.27" cy="14.14" r="1.32"/><circle id="Ellipse_26" data-name="Ellipse 26" class="cls-4" cx="11.11" cy="25.35" r="2.32"/></g></g></g></svg>`
  },
  {
    id: 3,
    text: 'Click and move dots to adjust your cluster',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.28 30"><defs><style>.cls-1{fill:#444;}.cls-2{fill:#73b0ac;stroke:#f7931e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#fff;}.cls-4{fill:#bf0000;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Group_2418" data-name="Group 2418"><rect id="Rectangle_175" data-name="Rectangle 175" class="cls-1" width="46.28" height="30"/></g><g id="Group_2420" data-name="Group 2420"><path id="Path_2542" data-name="Path 2542" class="cls-2" d="M11.11,25.38l3.82-11.17L11.11,6.83H22.78l15.49,7.38Z"/><circle id="Ellipse_22" data-name="Ellipse 22" class="cls-3" cx="14.68" cy="14.42" r="1.32"/><circle id="Ellipse_27" data-name="Ellipse 27" class="cls-3" cx="11.32" cy="25.42" r="1.32"/><circle id="Ellipse_23" data-name="Ellipse 23" class="cls-3" cx="22.53" cy="6.83" r="1.32"/><circle id="Ellipse_24" data-name="Ellipse 24" class="cls-3" cx="11.11" cy="6.83" r="1.32"/><circle id="Ellipse_25" data-name="Ellipse 25" class="cls-3" cx="38.27" cy="14.14" r="1.32"/><circle id="Ellipse_26" data-name="Ellipse 26" class="cls-4" cx="38.11" cy="14.35" r="2.32"/></g></g></g></svg>`
  }
]
